import React, { useState } from "react";
import { columnsDataDevelopment } from "./variables/columnsData";
import tableDataDevelopment from "./variables/tableDataDevelopment.json";
import UserTable from "./components/UserTable";
import UserCreation from "./components/UserCreation";

const Users = () => {
  const [createUser, setCreateUser] = useState(false);
  const [userId, setUserId] = useState("");
  return (
    <>
      <div className="mt-5 grid h-full gap-5">
        {!createUser && (
          <UserTable
            createUser={createUser}
            setCreateUser={setCreateUser}
            setUserId={setUserId}
            columnsData={columnsDataDevelopment}
            tableData={tableDataDevelopment}
          />
        )}
        {createUser && (
          <UserCreation createUser={createUser}
            setCreateUser={setCreateUser} userId={userId}/>
        )}
      </div>
    </>
  );
};

export default Users;
